



































import { Component, Mixins } from "vue-property-decorator";
import BalanceOverview from "defi/components/partial/BalanceOverview.vue";
import Schemes from "defi/components/schemes/Index.vue";
import mixins from "@/mixins";

@Component({
  components: {
    BalanceOverview,
    Schemes
  }
})
class IndexPage extends Mixins(mixins.page, mixins.processOrders) {
  needAuth = false;

  get appbar(): any {
    if (this.home) {
      return {
        title: this.$t("defi"),
        show: false,
        back: true,
        style: [
          {
            background:
              "linear-gradient(180deg, #0596FF 0%, rgba(5, 150, 255, 0) 100%)"
          }
        ],
        dark: true
      };
    }
    return {
      title: this.$t("defi"),
      show: true,
      back: false
    };
  }

  get title() {
    return this.$t("defi") as string;
  }

  get themeColor(): any {
    const { background, primary } = this.$vuetify.theme.currentTheme;
    return this.home ? primary : background;
  }

  get home() {
    const home = this.$route.query.home;
    return Boolean(home);
  }

  get bottomNav() {
    return this.home ? "" : "defi";
  }

  mounted() {
    // this.$store.dispatch("defi/account/loadWealthes");
    // this.$store.dispatch("defi/schemes/loadSchemes");
    // this.setProperties();

    window.location.replace("https://app.pando.im/earn");
  }
}
export default IndexPage;
